export default "__VITE_ASSET__65493f23__"